module.exports = __webpack_public_path__ + "static/img/04.0aaccbe1.png";